module.exports = __webpack_public_path__ + "static/media/image2.804fbea6.png";